export default "__VITE_ASSET__587ae67a__"